<template>
  <v-select
    v-model="internalValue"
    :clearable="clearable"
    :multiple="multiple"
    label="name"
    :options="supplierOptions"
    :filter="filterSupplier"
    :placeholder="placeholder || $t('products.supplier')"
    :class="['select-supplier', customClass]"
    :append-to-body="appendToBody"
    :disabled="disabled"
  >
    <template slot="no-options"> {{ $t("noRecord") }} </template>
    <template slot="option" slot-scope="option">
      <span>{{ option.name }}</span>
      <small v-if="option.nameFull && option.nameFull !== option.name" class="select-supplier-sub"> {{ option.nameFull }}</small>
    </template>
    <template slot="selected-option" slot-scope="option">
      <span :class="{ 'select-supplier-primary': multiple && isPrimary(option) }" :title="multiple && isPrimary(option) ? $t('products.primarySupplier') : ''">
        <md-icon v-if="multiple && isPrimary(option)" class="select-supplier-star">star</md-icon>{{ option.name }}
      </span>
    </template>
  </v-select>
</template>

<script>
// Lieferanten-Auswahl (einfach oder mehrfach). v-model = Id bzw. Array von Ids; bei Mehrfachauswahl ist der erste
// Eintrag der Hauptlieferant (Products.SupplierId), Reihenfolge = Reihenfolge der Auswahl.
export default {
  props: {
    value: {
      type: [Number, Array, null],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    // Optional eigene Optionen (z.B. nur die gemeinsamen Lieferanten eines Warenkorbs), sonst alle aus dem Store
    options: {
      type: Array,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  computed: {
    supplierOptions() {
      const source = this.options || this.$store.state.shippingData.supplierNames || [];
      return source.map((s) => ({ id: s.id, name: s.name, nameFull: s.nameFull, creditor: s.creditor, bankId: s.bankId }));
    },
    internalValue: {
      get() {
        if (this.multiple) {
          const ids = Array.isArray(this.value) ? this.value : [];
          return ids.map((id) => this.supplierOptions.find((s) => s.id === id)).filter((s) => s);
        }
        return this.value == null ? null : this.supplierOptions.find((s) => s.id === this.value) || null;
      },
      set(newValue) {
        if (this.multiple) {
          this.$emit(
            "input",
            (newValue || []).map((s) => s.id)
          );
        } else {
          this.$emit("input", newValue ? newValue.id : null);
        }
      },
    },
  },
  methods: {
    isPrimary(option) {
      return Array.isArray(this.value) && this.value.length > 0 && this.value[0] === option.id;
    },
    filterSupplier(options, search) {
      const q = (search || "").toLowerCase();
      return options.filter((s) => [s.name, s.nameFull, s.creditor, s.bankId].some((v) => v && String(v).toLowerCase().includes(q)));
    },
  },
  created() {
    if (!this.options && (!this.$store.state.shippingData.supplierNames || this.$store.state.shippingData.supplierNames.length === 0)) {
      this.$store.dispatch("shippingData/getSupplierNames");
    }
  },
};
</script>

<style lang="scss">
// Hinweis unter der Mehrfachauswahl (Produktdialoge): erster Eintrag = Hauptlieferant
.supplier-hint {
  font-size: 11px;
  color: #999;
  margin-top: 4px;
}
.select-supplier {
  .select-supplier-sub {
    color: #999;
    margin-left: 4px;
  }
  .select-supplier-primary {
    font-weight: 600;
  }
  .select-supplier-star.md-icon {
    font-size: 14px !important;
    width: 14px;
    min-width: 14px;
    height: 14px;
    margin: 0 2px 0 0;
    color: #f5a623 !important;
    vertical-align: -2px;
  }
}
</style>
